import taxReducer from "./taxSlice";

export default taxReducer;
